import React from 'react'

const decodeEntities = rawHTML =>
  React.createElement('span', { dangerouslySetInnerHTML: { __html: rawHTML } })

export default decodeEntities
